import { object, safeParse } from "valibot";
import {
  normalizePhone as normalizeContactPhone,
  requiredEmailSchema,
  requiredPhoneSchema,
} from "./contact-validation.ts";

export function normalizePhone(input: string) {
  return normalizeContactPhone(input);
}

export type ContactErrors = {
  email?: string;
  phone?: string;
};

export function validateContact(
  input: { email: string; phone: string },
  requiresPhone: boolean
) {
  const normalizedInput = requiresPhone
    ? { ...input, phone: normalizePhone(input.phone) }
    : input;
  const schema = requiresPhone
    ? object({ email: requiredEmailSchema, phone: requiredPhoneSchema })
    : object({ email: requiredEmailSchema });
  const result = safeParse(schema, normalizedInput);

  if (result.success) {
    const errors: ContactErrors = {};
    return { errors, value: result.output } as const;
  }

  const errors: ContactErrors = {};
  for (const issue of result.issues) {
    const field = issue.path?.[0]?.key;
    if ((field === "email" || field === "phone") && !errors[field]) {
      errors[field] = issue.message;
    }
  }
  return { errors, value: null } as const;
}
